import React, { useEffect, useState } from 'react'
import { Snackbar } from '@material-ui/core'

import { SnackbarContent } from '../'

import snackbarBus from '../../snackbarBus'

const initialSnackbar = {
  visible: false,
  message: '',
  variant: 'error',
  vertical: 'bottom',
  horizontal: 'left',
}

const SnackbarHost = () => {
  const [snackbar, setSnackbar] = useState(initialSnackbar)

  useEffect(() => {
    const unsubscribe = snackbarBus.subscribe((event) => {
      if (event.type === 'SHOW') {
        setSnackbar({ ...initialSnackbar, ...event.payload, visible: true })
      }

      if (event.type === 'HIDE') {
        setSnackbar((s) => ({ ...s, visible: false }))
      }
    })

    return unsubscribe
  }, [])

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return

    setSnackbar((s) => ({ ...s, visible: false }))
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: snackbar.vertical,
        horizontal: snackbar.horizontal,
      }}
      open={snackbar.visible}
      onClose={handleClose}
      autoHideDuration={6000}
    >
      <SnackbarContent
        onClose={handleClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </Snackbar>
  )
}

export default SnackbarHost
